import CircularProgress from "@mui/material/CircularProgress";
import { FormattedMessage } from "react-intl";
import { Link } from "react-router-dom";
import ChevronIcon from "svg-icons/chevron-icon.js";
import SnackbarModal from "component/shared/snackbar";
import { APP_PREFIX_PATH } from "configs/AppConfig.js";
import ProfileTextField from "./ProfileTextField";
import ProfileDateField from "./ProfileDateField";
import ProfilePhoneField from "./ProfilePhoneField";

export default function ProfileForm({
  id,
  dir,
  control,
  errors,
  onSubmit,
  buttonSpinner,
  snackbar,
}) {
  return (
    <form onSubmit={onSubmit}>
      <ProfileTextField
        control={control}
        name="username"
        labelId="username"
        error={errors?.username}
        disabled
      />
      <ProfileTextField
        control={control}
        name="email"
        labelId="email"
        error={errors?.email}
        disabled
      />
      <ProfileTextField
        control={control}
        name="firstName"
        labelId="fname"
        error={errors?.firstName}
      />
      <ProfileTextField
        control={control}
        name="lastName"
        labelId="lname"
        error={errors?.lastName}
      />
      <ProfileDateField control={control} error={errors?.birthDate} />
      <ProfileTextField
        control={control}
        name="address"
        labelId="address"
        error={errors?.address}
      />
      <ProfilePhoneField control={control} errors={errors} />

      <div className="text-center">
        <button
          type="submit"
          className="main-btn"
          style={{ marginInlineStart: "auto" }}
        >
          <span>
            {buttonSpinner ? (
              <span>
                <CircularProgress sx={{ color: "#fff" }} size={26} />
              </span>
            ) : (
              <>
                <span style={{ marginInlineEnd: "0.5rem" }}>
                  <FormattedMessage id="confirm" />
                </span>
                <ChevronIcon width={12} height={12} color="#FFFFFF" />
              </>
            )}
          </span>
        </button>
      </div>

      <div className={`mt-4 ${dir === "rtl" ? "text-start" : "text-end"}`}>
        <Link to={`${APP_PREFIX_PATH}/resetPass/${id}`}>
          <span style={{ color: "var(--main-color)" }}>
            <u>
              <FormattedMessage id="resetPass" />
            </u>
          </span>
        </Link>
      </div>

      <SnackbarModal
        open={snackbar.open}
        onClose={snackbar.onClose}
        severity={snackbar.severity}
        message={snackbar.message}
      />
    </form>
  );
}
